<template>
  <div class="row" v-if="paymentProviderAccount">
    <div class="col-12 d-flex align-items-center">
      <h2>{{ paymentProviderAccount.name }}</h2>
      <router-link class="btn btn-primary btn-sm ms-3"
                   :to="{name: ROUTES.PAYMENT_PROVIDER_ACCOUNTS.EDIT, params: {id: paymentProviderAccount.id}}">
        {{ $t('payment_provider_accounts.edit') }}
      </router-link>
    </div>

    <div class="col-12 mt-4">
      <div class="card">
        <div class="card-body">
          <show-row :label="$t('payment_provider_accounts.id')" :value="String(paymentProviderAccount.id)"/>
          <show-row :label="$t('payment_provider_accounts.organization_id')" :value="String(paymentProviderAccount.organization_id)"/>
          <show-row :label="$t('payment_provider_accounts.provider_key')" :value="paymentProviderAccount.provider_key"/>
          <show-row :label="$t('payment_provider_accounts.name')" :value="paymentProviderAccount.name"/>
          <show-row :label="$t('payment_provider_accounts.status')" :value="paymentProviderAccount.status"/>
          <show-row :label="$t('payment_provider_accounts.api_key_configured')" :value="apiKeyConfigured"/>
          <show-row :label="$t('payment_provider_accounts.profile_id')" :value="paymentProviderAccount.profile_id"/>
          <show-row :label="$t('payment_provider_accounts.default_currency')" :value="paymentProviderAccount.default_currency"/>
          <show-row :label="$t('payment_provider_accounts.webhook_url')" :value="paymentProviderAccount.webhook_url"/>
          <show-row :label="$t('payment_provider_accounts.created_at')" :value="formatDate(paymentProviderAccount.created_at, 'datetime') || '-'"/>
          <show-row :label="$t('payment_provider_accounts.updated_at')" :value="formatDate(paymentProviderAccount.updated_at, 'datetime') || '-'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {usePaymentProviderAccountStore} from "@/stores/payment_provider_account";
import {ROUTES} from "@/scripts/constants";
import ShowRow from "@/components/ShowRow.vue";

export default {
  name: 'PaymentProviderAccountsShow',
  components: {
    ShowRow,
  },
  setup() {
    return {
      paymentProviderAccountStore: usePaymentProviderAccountStore(),
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    },
    paymentProviderAccount() {
      return this.paymentProviderAccountStore.payment_provider_account
    },
    apiKeyConfigured() {
      return this.paymentProviderAccount?.api_key_configured ? this.$t('yes') : this.$t('no')
    }
  },
  created() {
    this.paymentProviderAccountStore.show(this.$route.params.id).then(() => {
      this.setTitle(this.paymentProviderAccount.name)
    })
  }
}
</script>
